<template>
  <div class="fee" role="alert">
    <div class="fee_content">
      <span
        class="fee_icon"
        :style="{ '--icon-url': `url(${informationOutlineIcon})` }"
        aria-hidden="true"
      ></span>
      <div class="fee_text">
        <div class="fee_title">{{ $t('message.fee_notice', {token, fee}) }}</div>
        <div class="note">
          {{ $t('message.fee_subject_to_change') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import informationOutlineIcon from '@/assets/img/information-outline.svg'

export default {
  name: 'feeNotice',
  props: {
    token: {
      type: String,
      default: ''
    },
    fee: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      informationOutlineIcon
    }
  }
}

</script>

<style scoped>
  .fee {
    width: 100%;
    box-sizing: border-box;
    border: none;
    border-left: 3px solid #6a11cb;
    border-radius: 0;
    background: #fff;
    padding: 14px 16px;
  }
  .fee_content {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .fee_icon {
    width: 20px;
    height: 20px;
    margin-top: 1px;
    background: #F59E0B;
    flex: 0 0 auto;
    -webkit-mask-image: var(--icon-url);
    mask-image: var(--icon-url);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }
  .fee_text {
    flex: 1;
  }
  .fee_title {
    color: #374151;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.5;
  }
  .note {
    margin-top: 4px;
    color: #374151;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.5;
  }
</style>
